import { REGISTRATION_STATES } from '@repo/api-kit/queries/registration-states';
import { ROUTE_PARAMS } from '../route-params';

export const BE_EXISTING_COMPANY_MAPPING = {
  [REGISTRATION_STATES.DECLARED_NUMBER_OF_EMPLOYEES]: {
    url: '/screening/:organization_id/declared-number-of-employees',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.USER_PHONE_NUMBER]: {
    url: '/signup/phone-number',
    routeParams: [],
  },
  [REGISTRATION_STATES.COMPANIES_SEARCH]: {
    url: '/organizations/:organization_id/companies',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.ACTIVITY_NOT_ALLOWED]: {
    url: '/organizations/:organization_id/not-supported-activity',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_INFO]: {
    url: '/organizations/:organization_id/info',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_ADDRESS]: {
    url: '/organizations/:organization_id/address',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.BUSINESS_ACTIVITY_ENTITY_TYPE]: {
    url: '/organizations/:organization_id/business-activity',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_FINANCES]: {
    url: '/organizations/:organization_id/finances',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_ACTIVITY]: {
    url: '/organizations/:organization_id/activity',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.OWNER_SELECT]: {
    url: '/organizations/:organization_id/owners/select',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.OWNER_INFO]: {
    url: '/organizations/:organization_id/owners/:owner_id/info',
    routeParams: [ROUTE_PARAMS.ORGANIZATION, ROUTE_PARAMS.OWNER],
  },
  [REGISTRATION_STATES.OWNER_ADDITIONAL_INFO]: {
    url: '/organizations/:organization_id/owners/:owner_id/additional-info',
    routeParams: [ROUTE_PARAMS.ORGANIZATION, ROUTE_PARAMS.OWNER],
  },
  [REGISTRATION_STATES.OWNER_PHONE_NUMBER]: {
    url: '/organizations/:organization_id/owners/:owner_id/phone-number',
    routeParams: [ROUTE_PARAMS.ORGANIZATION, ROUTE_PARAMS.OWNER],
  },
  [REGISTRATION_STATES.OWNER_POWER_GIVER]: {
    url: '/organizations/:organization_id/owners/:owner_id/power-giver',
    routeParams: [ROUTE_PARAMS.ORGANIZATION, ROUTE_PARAMS.OWNER],
  },
  [REGISTRATION_STATES.COMPANY_BENEFICIARIES]: {
    url: '/organizations/:organization_id/memberships/beneficiaries',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_NATURE_OF_OPS]: {
    url: '/organizations/:organization_id/nature-of-ops',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.OWNER_ADDRESS]: {
    url: '/organizations/:organization_id/owners/:owner_id/address',
    routeParams: [ROUTE_PARAMS.ORGANIZATION, ROUTE_PARAMS.OWNER],
  },
  [REGISTRATION_STATES.COMPANY_PRICE_PLAN_SELECTION]: {
    url: '/organizations/:organization_id/pricing',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_CONTRACT]: {
    url: '/organizations/:organization_id/contract',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_PENDING_CONTRACT_SIGN]: {
    url: '/organizations/:organization_id/pending-contract',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
  [REGISTRATION_STATES.COMPANY_CONTRACT_SIGNED]: {
    url: '/organizations/:organization_id/congrats',
    routeParams: [ROUTE_PARAMS.ORGANIZATION],
  },
};
